// extracted by mini-css-extract-plugin
export default {"spriteAnimation":"orangeAnimation_spriteAnimation__0ISgn","frame":"orangeAnimation_frame__mcQAe","visible":"orangeAnimation_visible__15yxn","hidden":"orangeAnimation_hidden__rvVmG"};